"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function () {
    return function (resume, retryCount) { return setTimeout(resume, Math.pow(2, (retryCount - 1))); };
});
//# sourceMappingURL=exponent-refresh-error-policy.js.map


// WEBPACK FOOTER //
// ../src/exponent-refresh-error-policy.ts